import { Message } from '..'
import { AiOutlineApartment, AiOutlineTeam, AiOutlineUserAdd, AiOutlineAppstoreAdd, AiOutlineEdit, AiOutlineUpload, AiOutlineFileDone, AiOutlineGlobal, AiOutlineFileExcel, AiOutlineUsergroupAdd, AiOutlineSetting, AiOutlinePlusCircle } from "react-icons/ai"
import { FaPenAlt, FaTrash, FaSearch, FaBroom, FaCheckCircle, FaTimesCircle, FaQuestion } from 'react-icons/fa'
import { DatatableWrapper, Filter, Pagination, PaginationOptions, EmptyTablePlaceholder, TableBody, TableHeader } from 'react-bs-datatable'
import { Col, Row, Table } from 'react-bootstrap'
import React, { useState, useEffect } from "react"
import PhoneInput from 'react-phone-number-input'
import useBranchesHook from '../../api/branches'
import useUsersHook from '../../api/users'
import useUploadHook from '../../api/upload'
import useBranchUsersHook from '../../api/branch-users';
import moment from 'moment'

import * as Yup from "yup"
import "yup-phone"
import * as XLSX from 'xlsx'
import * as FileSaver from "file-saver"

import {
  inputCheckBox,
  inputText,
} from '../../utils/dynamicForm'


var FormBranches = ({
  id,
  edit,
  users,
  auth,
  authProperties,
  members,
  formCleanHandler,
  register,
  isError,
  errors,
  watch,
  isLoadingPost,
  handleSubmit,
  submitHandler,
  isSuperAdmin,
  latitudeBranch,
  longitudeBranch,
  radiusBranch,
  setMembersValue,
  setUsersValue
}) => {

  const { updateBranch } = useBranchesHook({ page: 1, q: '' })

  var { isLoading: isLoadingBranch, error: errorUpdate, mutateAsync: mutateAsyncUpdate, isSuccess: isSuccessUpdate, data: dataSuccessUpdate } = updateBranch
  const { postUserByInput } = useUsersHook({ limit: 100000, page: 1 })
  const { mutateAsync: mutateAsyncPostSearchUser } = postUserByInput
  const { postUpload } = useUploadHook()
  var { isLoading: isLoadingUpload, error: errorUpload, mutateAsync: mutateAsyncUpload } = postUpload

  var urlComplete = `${process.env.REACT_APP_URL_DOMAIN}`

  const headers = [
    { title: 'Nombre del Abonado Principal', prop: 'name', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Estado', prop: 'active', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Identificación', prop: `identification`, alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Número Celular', prop: 'phone', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Email', prop: 'email', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Ingreso Contraseña', prop: 'accountValidationInitialPasswordToken', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Bloqueo General', prop: 'blocked', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Acciones', prop: '', alignment: { horizontal: 'center' } }
  ]

  const headersUsers = [
    { title: 'Nombre del Usuario', prop: 'name', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Estado', prop: 'active', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Rol', prop: 'role', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Identificación', prop: `identification`, alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Número Celular', prop: 'phone', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Email', prop: 'email', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Ingreso Contraseña', prop: 'accountValidationInitialPasswordToken', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Bloqueo General', prop: 'blocked', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Acciones', prop: '', alignment: { horizontal: 'center' } }
  ]

  const headersBranchUsers = [
    { title: 'Nombre del Usuario', prop: 'name', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Apellido del Usuario', prop: 'lastname', alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Identificación', prop: `identification`, alignment: { horizontal: 'center' }, isFilterable: true },
    { title: 'Acciones', prop: '', alignment: { horizontal: 'center' } }
  ]

  // Inicio - User
  const [idUser, setIdUser] = useState('')
  const [typeIdentificationUser, setTypeIdentificationUser] = useState(undefined)
  const [identificationUser, setIdentificationUser] = useState('')
  const [nameUser, setNameUser] = useState('')
  const [lastNameUser, setLastNameUser] = useState('')
  const [emailUser, setEmailUser] = useState('')
  const [phoneNumberUser, setPhoneNumberUser] = useState()
  const [sexUser, setSexUser] = useState('')
  const [birthdayUser, setBirthdayUser] = useState('')
  const [editUser, setEditUser] = useState(false)
  const [inputSearchUser, setInputSearchUser] = useState('')
  const [isActiveUser, setIsActiveUser] = useState(false)
  const [roleUser, setRoleUser] = useState('')
  const [isDisabledUser, setIsDisabledUser] = useState(true)
  const [isDisabledUserEdit, setIsDisabledUserEdit] = useState(true)
  const [errorsListUser, setErrorsListUser] = useState('')
  const [branchUsers, setBranchUsers] = useState([])


  const cleanUser = async () => {

    setInputSearchUser('')
    setIsDisabledUser(true)
    setIsDisabledUserEdit(true)
    setIdUser('')
    setTypeIdentificationUser('')
    setIdentificationUser('')
    setBirthdayUser('')
    setSexUser('')
    setNameUser('')
    setLastNameUser('')
    setEmailUser('')
    setPhoneNumberUser('')
    setIsActiveUser(false)
    setRoleUser('')
    setEditUser(false)
    setErrorsListUser('')
    document.getElementById('isActiveUser').removeAttribute('checked')

  }

  const addUser = async () => {

    let formatDateBirthday = ''
    // Validacion de la fecha por conversion del componente web
    if (birthdayUser != '') {
      let dateArray = birthdayUser.split('-')
      formatDateBirthday = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`
    }

    const branchUpdate = await mutateAsyncUpdate({
      _id: id,
      users: {
        _id: idUser,
        typeIdentification: typeIdentificationUser,
        identification: identificationUser,
        birthday: formatDateBirthday,
        sex: sexUser,
        name: nameUser,
        lastname: lastNameUser,
        email: emailUser,
        phone: phoneNumberUser,
        role: roleUser,
        active: isActiveUser
      }, type: 'update_branch_users', urlComplete: urlComplete
    })

    users.splice(0)

    var userList = JSON.parse(branchUpdate)

    for (let i = 0; i < userList.length; i++) {
      users.push({
        _id: userList[i].user._id,
        typeIdentification: userList[i].user.typeIdentification,
        identification: userList[i].user.identification,
        birthday: userList[i].user.birthday,
        sex: userList[i].user.sex,
        name: userList[i].user.name,
        lastname: userList[i].user.lastname,
        email: userList[i].user.email,
        phone: userList[i].user.phone,
        accountValidationEmailToken: userList[i].user.accountValidationEmailToken,
        accountValidationPhoneToken: userList[i].user.accountValidationPhoneToken,
        accountValidationInitialPasswordToken: userList[i].user.accountValidationInitialPasswordToken,
        active: userList[i].active,
        role: userList[i].typeUser
      })
    }
    cleanUser()
    document.getElementById("close-user-branch").click()
  }

  const editUserFunction = (idUser) => {
    setEditUser(true)
    setIsDisabledUser(true)
    setIsDisabledUserEdit(false)
    var userFound = users.find((e) => e._id == idUser)

    setIdUser(userFound._id)
    setTypeIdentificationUser(userFound.typeIdentification)
    setIdentificationUser(userFound.identification)
    setBirthdayUser(userFound.birthday != undefined ? userFound.birthday.substring(0, 10) : '')
    setSexUser(userFound.sex)
    setNameUser(userFound.name)
    setLastNameUser(userFound.lastname)
    setEmailUser(userFound.email)
    setPhoneNumberUser(userFound.phone)
    setIsActiveUser(userFound.active)
    setRoleUser(userFound.role == 'Admin' ? 'ADMIN_BRANCH' : 'MONITOR_BRANCH')
    if (userFound.active)
      document.getElementById("isActiveUser").checked = true
    else
      document.getElementById("isActiveUser").checked = false
  }

  const schemaSearchUser = Yup.object().shape({
    search: Yup.string().required("* Ingrese un correo electrónico, un número telefónico o una identificación"),
  })

  const deleteUserFunction = async (idUser) => {

    await mutateAsyncUpdate({
      _id: id,
      users: {
        _id: idUser,
      },
      type: 'delete_branch_users',
    })

    var userFinal = []

    for (let i = 0; i < users.length; i++) {
      if (users[i]._id != idUser) {
        userFinal.push(users[i])
      }

    }
    users.splice(0)
    setUsersValue(userFinal)
  }

  const searchUser = async () => {

    if (inputSearchUser == '') {
      setErrorsListUser('Ingrese un valor de búsqueda')
      return false
    }

    const retorno = await mutateAsyncPostSearchUser({ input: inputSearchUser })
    var errorMessage = ''
    cleanUser()

    if (retorno._id == undefined) {
      errorMessage = '* No se ha encontrado ningún usuario. Ingrese un nuevo usuario'
      setErrorsListUser(errorMessage)
      setEditUser(false)
      setIsDisabledUser(false)
      setIsDisabledUserEdit(false)
    } else {
      setEditUser(true)
      setIsDisabledUser(true)
      setIsDisabledUserEdit(false)
    }

    setIdUser(retorno && retorno._id != undefined ? retorno._id : '')
    setTypeIdentificationUser(retorno && retorno.typeIdentification != undefined ? retorno.typeIdentification : '')
    setIdentificationUser(retorno && retorno.identification != undefined ? retorno.identification : '')
    setBirthdayUser(retorno && retorno.birthday != undefined ? retorno.birthday.substring(0, 10) : '')
    setSexUser(retorno && retorno.sex != undefined ? retorno.sex : '')
    setNameUser(retorno && retorno.name != undefined ? retorno.name : '')
    setLastNameUser(retorno && retorno.lastname != undefined ? retorno.lastname : '')
    setEmailUser(retorno && retorno.email != undefined ? retorno.email : '')
    setPhoneNumberUser(retorno && retorno.phone != undefined ? retorno.phone : '')
    setIsActiveUser(retorno && retorno.active != undefined ? retorno.active : false)
  }

  const formValidationSearchUser = async () => {
    let validacion = undefined
    try {

      validacion = await schemaSearchUser.validate({ search: inputSearchUser })
    }
    catch (errors) {
      setErrorsListUser(errors.message)
    }

    if (validacion !== '') {
      searchUser()
    }
  }

  // Fin - User


  // Inicio - Branch User

  const { getBranchUsersByBranch, putBranchUser, deleteBranchUser, postBranchUser, postMultipleBranchUsers } = useBranchUsersHook()
  const [isCreateBranchUser, setIsCreateBranchUser] = useState(true)

  const getBranchAllUsers = async () => {
    if (id) {
      await getBranchUsersByBranch.mutate(id, {
        onSuccess: (data) => {
          setBranchUsers(data);
        },
        onError: (error) => {
          console.error('Error al obtener los usuarios:', error);
        },
      });
    }
  }

  useEffect(() => {
    getBranchAllUsers()
  }, [id]);

  const addBranchUser = async () => {
    const newBranchUser = {
      identification: identificationUser,
      name: nameUser,
      lastname: lastNameUser,
      branch: id
    }

    if (isCreateBranchUser) {
      await postBranchUser.mutate(newBranchUser, {
        onSuccess: () => {
          getBranchAllUsers()
          document.getElementById("close-user-branch").click()
          cleanUser()
        },
        onError: (error) => {
          window.alert(error)
        },
      });
    } else {
      const updateBranchUser = {
        idUser: idUser,
        data: newBranchUser
      }
      await putBranchUser.mutate(updateBranchUser, {
        onSuccess: () => {
          getBranchAllUsers()
          document.getElementById("close-user-branch").click()
          cleanUser()
        },
        onError: (error) => {
          window.alert(error)
        },
      })
    }
  }

  const createBranchUserFunction = () => {
    setIsCreateBranchUser(true)
    setIdUser("")
    setIdentificationUser("")
    setNameUser("")
    setLastNameUser("")
  }

  const editBranchUserFunction = (branchUser) => {
    setIsCreateBranchUser(false)
    setIdUser(branchUser._id)
    setIdentificationUser(branchUser.identification)
    setNameUser(branchUser.name)
    setLastNameUser(branchUser.lastname)
  }

  const deleteBranchUserFunction = async (idDeleteUser) => {
    await deleteBranchUser.mutate(idDeleteUser, {
      onSuccess: () => {
        getBranchAllUsers()
      },
      onError: (error) => {
        window.alert(error)
      },
    })
  }

  var handleFileChangeBranchUser = (e) => {
    if (e.target.files) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = async (event) => {
        const data = event.target.result;
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const arrayData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const dataWithoutHeader = arrayData.slice(1);
        var jsonData = []
        dataWithoutHeader.forEach((item) => {
          jsonData.push({
            identification: item[0],
            name: item[1],
            lastname: item[2],
            branch: id
          })
        })
        await postMultipleBranchUsers.mutate(jsonData, {
          onSuccess: (res) => {
            window.alert(res.message)
            getBranchAllUsers()
          },
          onError: (error) => {
            window.alert(error)
          },
        });
      };

      reader.onerror = (error) => {
        console.error("Error al leer el archivo:", error);
      };
    }
  };

  // Fin - Branch User


  // Inicio - Member
  const [idMember, setIdMember] = useState('')
  const [typeIdentificationMember, setTypeIdentificationMember] = useState('')
  const [identificationMember, setIdentificationMember] = useState('')
  const [nameMember, setNameMember] = useState('')
  const [lastNameMember, setLastNameMember] = useState('')
  const [emailMember, setEmailMember] = useState('')
  const [phoneNumberMember, setPhoneNumberMember] = useState()
  const [validationPhone, setValidationPhone] = useState()
  const [sexMember, setSexMember] = useState('')
  const [birthdayMember, setBirthdayMember] = useState('')
  const [editMember, setEditMember] = useState(false)
  const [inputSearchMember, setInputSearchMember] = useState('')
  const [isActiveMember, setIsActiveMember] = useState(true)
  const [isDisabledMember, setIsDisabledMember] = useState(true)
  const [isDisabledMemberEdit, setIsDisabledMemberEdit] = useState(true)
  const [networkMember, setNetworkMember] = useState('')
  const [errorsListMember, setErrorsListMember] = useState('')


  const cleanMember = async () => {

    setInputSearchMember('')
    setIsDisabledMember(true)
    setIsDisabledMemberEdit(true)
    setIdMember('')
    setTypeIdentificationMember('')
    setIdentificationMember('')
    setBirthdayMember('')
    setSexMember('')
    setNameMember('')
    setLastNameMember('')
    setEmailMember('')
    setPhoneNumberMember('')
    setValidationPhone('')
    setIsActiveMember(false)
    setEditMember(false)
    setErrorsListMember('')
    setNetworkMember('')
    document.getElementById('isActiveMember').removeAttribute('checked')

  }

  const addMember = async () => {

    let formatDateBirthday = ''
    // Validacion de la fecha por conversion del componente web
    if (birthdayMember != '') {
      let dateArray = birthdayMember.split('-')
      formatDateBirthday = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`
    }

    const branchUpdate = await mutateAsyncUpdate({
      _id: id,
      members: {
        _id: idMember,
        typeIdentification: typeIdentificationMember,
        identification: identificationMember,
        birthday: formatDateBirthday,
        sex: sexMember,
        name: nameMember,
        lastname: lastNameMember,
        email: emailMember,
        phone: phoneNumberMember,
        active: isActiveMember,
        role: 'MEMBER_BRANCH',
      }, type: 'update_branch_members'
    })

    members.splice(0)

    var memberList = JSON.parse(branchUpdate)

    for (let i = 0; i < memberList.length; i++) {
      members.push({
        _id: memberList[i].user._id,
        typeIdentification: memberList[i].user.typeIdentification,
        identification: memberList[i].user.identification,
        birthday: memberList[i].user.birthday,
        sex: memberList[i].user.sex,
        name: memberList[i].user.name,
        lastname: memberList[i].user.lastname,
        email: memberList[i].user.email,
        phone: memberList[i].user.phone,
        accountValidationEmailToken: memberList[i].user.accountValidationEmailToken,
        accountValidationPhoneToken: memberList[i].user.accountValidationPhoneToken,
        accountValidationInitialPasswordToken: memberList[i].user.accountValidationInitialPasswordToken,
        active: memberList[i].active,
        network: memberList[i].network._id,
        branch: id,
      })
    }
    cleanMember()
    document.getElementById("close-branch-member").click()
  }

  const editMemberFunction = async (idMember) => {
    setEditMember(true)
    setIsDisabledMember(true)
    setIsDisabledMemberEdit(false)
    var memberFound = members.find((e) => e._id == idMember)
    setIdMember(memberFound._id)
    setTypeIdentificationMember(memberFound.typeIdentification)
    setIdentificationMember(memberFound.identification)
    setBirthdayMember(memberFound.birthday != undefined ? memberFound.birthday.substring(0, 10) : '')
    setSexMember(memberFound.sex)
    setNameMember(memberFound.name)
    setLastNameMember(memberFound.lastname)
    setEmailMember(memberFound.email)
    setPhoneNumberMember(memberFound.phone)
    setIsActiveMember(memberFound.active)
    setNetworkMember(memberFound.network)
    setValidationPhone(memberFound.accountValidationPhoneToken)

    if (memberFound.active)
      document.getElementById("isActiveMember").checked = true
    else
      document.getElementById("isActiveMember").checked = false
  }

  const schemaSearchMember = Yup.object().shape({
    search: Yup.string().required("* Ingrese un correo electrónico, un número telefónico o una identificación"),
  })

  const deleteMemberFunction = async (idMember) => {

    await mutateAsyncUpdate({
      _id: id,
      members: {
        _id: idMember,
      },
      type: 'delete_branch_members',
    })

    var memberFinal = []

    for (let i = 0; i < members.length; i++) {
      if (members[i]._id != idMember) {

        memberFinal.push(members[i])

      }
    }

    members.splice(0)
    setMembersValue(memberFinal)

    document.getElementById("icon-tab-1") != undefined ? document.getElementById("icon-tab-1").click() : ''
  }

  const searchMember = async () => {

    if (inputSearchMember == '') {
      setErrorsListMember('Ingrese un valor de búsqueda')
      return false
    }

    const retorno = await mutateAsyncPostSearchUser({ input: inputSearchMember })
    var errorMessage = ''
    cleanMember()

    if (retorno._id == undefined) {
      errorMessage = '* No se ha encontrado ningún usuario. Ingrese un nuevo usuario'
      setErrorsListMember(errorMessage)
      setEditMember(false)
      setIsDisabledMember(false)
      setIsDisabledMemberEdit(false)
    } else {
      setEditMember(true)
      setIsDisabledMember(true)
      setIsDisabledMemberEdit(false)
    }

    setIdMember(retorno && retorno._id != undefined ? retorno._id : '')
    setTypeIdentificationMember(retorno && retorno.typeIdentification != undefined ? retorno.typeIdentification : '')
    setIdentificationMember(retorno && retorno.identification != undefined ? retorno.identification : '')
    setBirthdayMember(retorno && retorno.birthday != undefined ? retorno.birthday.substring(0, 10) : '')
    setSexMember(retorno && retorno.sex != undefined ? retorno.sex : '')
    setNameMember(retorno && retorno.name != undefined ? retorno.name : '')
    setLastNameMember(retorno && retorno.lastname != undefined ? retorno.lastname : '')
    setEmailMember(retorno && retorno.email != undefined ? retorno.email : '')
    setPhoneNumberMember(retorno && retorno.phone != undefined ? retorno.phone : '')
    setIsActiveMember(retorno && retorno.active != undefined ? retorno.active : false)
  }

  const formValidationSearchMember = async () => {
    let validacion = undefined
    try {

      validacion = await schemaSearchMember.validate({ search: inputSearchMember })
    }
    catch (errors) {
      setErrorsListMember(errors.message)
    }

    if (validacion !== '') {
      searchMember()
    }
  }

  var handleFileChange = (e) => {
    if (e.target.files) {
      var reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      errorUpload = ''
      reader.onload = async () => {
        var formData = new FormData()
        formData.append('file', e.target.files[0])

        var uploadResponse = await mutateAsyncUpload({ type: 'upload-members', formData, id: id })

        var fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        var fileExtension = ".xlsx"

        var workSheet = XLSX.utils.json_to_sheet(uploadResponse.resultado_excel);
        XLSX.utils.sheet_add_aoa(workSheet, [["ABONADO", "MAIL", "RESPUESTA"]], { origin: "A1" })
        var workBook = { Sheets: { data: workSheet }, SheetNames: ["data"] }
        var excelBuffer = XLSX.write(workBook, { bookType: "xlsx", type: "array" })
        var data = new Blob([excelBuffer], { type: fileType })
        FileSaver.saveAs(data, 'Respuesta - Proceso subida de abonados' + fileExtension)

        members.splice(0)

        if (uploadResponse != undefined) {

          for (let i = 0; i < uploadResponse.resultado_members.members.length; i++) {
            members.push({
              _id: uploadResponse.resultado_members.members[i].user._id,
              typeIdentification: uploadResponse.resultado_members.members[i].user.typeIdentification,
              identification: uploadResponse.resultado_members.members[i].user.identification,
              birthday: uploadResponse.resultado_members.members[i].user.birthday,
              sex: uploadResponse.resultado_members.members[i].user.sex,
              name: uploadResponse.resultado_members.members[i].user.name,
              lastname: uploadResponse.resultado_members.members[i].user.lastname,
              email: uploadResponse.resultado_members.members[i].user.email,
              phone: uploadResponse.resultado_members.members[i].user.phone,
              accountValidationEmailToken: uploadResponse.resultado_members.members[i].user.accountValidationEmailToken,
              accountValidationPhoneToken: uploadResponse.resultado_members.members[i].user.accountValidationPhoneToken,
              accountValidationInitialPasswordToken: uploadResponse.resultado_members.members[i].user.accountValidationInitialPasswordToken,
              active: uploadResponse.resultado_members.members[i].active,
              network: uploadResponse.resultado_members.members[i].network._id,
              branch: id,
            })
          }

        }

      }
    }

  }
  // Fin - Member

  const generateReportUsers = async () => {


    const jsonFromTsObjectArray = members.map(value => ({
      'TIPO IDENTIFICACION': value.typeIdentification,
      'IDENTIFICACION': value.identification,
      'FECHA NACIMIENTO': value.birthday,
      'SEXO': value.sex,
      'NOMBRES': value.name,
      'APELLIDOS': value.lastname,
      'CORREO ELECTRONICO': value.email,
      'TELEFONO': value.phone,
      'CUENTA VALIDADA': value.accountValidationInitialPasswordToken == undefined ? 'VALIDADA' : 'NO VALIDADA',
      'FECHA REGISTRO': value.accountValidationInitialPasswordToken == undefined ? moment(value.accountValidationInitialPasswordDate).format("YYYY-MM-DD HH:mm:ss") : '',
      'FECHA VENCIMIENTO': value.accountValidationInitialPasswordToken == undefined ? moment(value.accountValidationInitialPasswordDate).add(1, 'years').format('YYYY-MM-DD HH:mm:ss') : '',
      'ACTIVO': value.active ? 'SI' : 'NO',
      'BLOQUEO LICENCIA': value.disabledByLicense ? 'SI' : 'NO',
      'BLOQUEO GENERAL': value.blocked ? 'SI' : 'NO',
    }))

    const worksheet = XLSX.utils.json_to_sheet(jsonFromTsObjectArray)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Listado de Abonados Principales")
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
    FileSaver(blob, "users.xlsx")
  }


  // Actualizacion de configuraciones
  var [isAuth, setIsAuth] = useState(false)
  var [authProperUrl, setAuthProperUrl] = useState('')
  var [authProperMethod, setAuthProperMethod] = useState('')
  var [authProperType, setAuthProperType] = useState('')
  var [showAuthProperties, setShowAuthProperties] = useState(false)
  var [authProperHeader, setAuthProperHeader] = useState([])
  var [authProperParams, setAuthProperParams] = useState([])
  var [authProperBody, setAuthProperBody] = useState([])
  var [authProperResponse, setAuthProperResponse] = useState([])
  var [editAuthPropertyHeader, setEditAuthPropertyHeader] = useState(false)
  var [authPropertyHeaderId, setAuthPropertyHeaderId] = useState('')
  var [authPropertyHeaderKey, setAuthPropertyHeaderKey] = useState('')
  var [authPropertyHeaderValue, setAuthPropertyHeaderValue] = useState('')
  var authPropertyHeaderList = []
  var [editAuthPropertyParams, setEditAuthPropertyParams] = useState(false)
  var [authPropertyParamsId, setAuthPropertyParamsId] = useState('')
  var [authPropertyParamsKey, setAuthPropertyParamsKey] = useState('')
  var [authPropertyParamsValue, setAuthPropertyParamsValue] = useState('')
  var authPropertyParamsList = []
  var [editAuthPropertyBody, setEditAuthPropertyBody] = useState(false)
  var [authPropertyBodyId, setAuthPropertyBodyId] = useState('')
  var [authPropertyBodyKey, setAuthPropertyBodyKey] = useState('')
  var [authPropertyBodyValue, setAuthPropertyBodyValue] = useState('')
  var authPropertyBodyList = []
  var [editAuthPropertyResponse, setEditAuthPropertyResponse] = useState(false)
  var [authPropertyResponseId, setAuthPropertyResponseId] = useState('')
  var [authPropertyResponseKey, setAuthPropertyResponseKey] = useState('')
  var [authPropertyResponseValue, setAuthPropertyResponseValue] = useState('')
  var authPropertyResponseList = []
  var [showPreInscripctionDetail, setShowPreInscripctionDetail] = useState(false)

  useEffect(() => {
    if (edit) {
      if (auth) {
        setIsAuth(true)
        setShowAuthProperties(true)
        if(document.getElementById("isAuth")!= null){
          document.getElementById("isAuth").checked = true;
        }
        setAuthProperUrl(authProperties.url)
        setAuthProperMethod(authProperties.method)
        setAuthProperType(authProperties.type)

        if (authProperties.type == 'Consultar Usuarios') {
          setShowPreInscripctionDetail(true)
        } else {
          setShowPreInscripctionDetail(false)
        }
        setEditAuthPropertyHeader(false)
        setAuthPropertyHeaderId('')
        setAuthPropertyHeaderKey('')
        setAuthPropertyHeaderValue('')
        setAuthProperHeader(authProperties.header)
        authPropertyHeaderList = authProperties.header

        setEditAuthPropertyParams(false)
        setAuthPropertyParamsId('')
        setAuthPropertyParamsKey('')
        setAuthPropertyParamsValue('')
        setAuthProperParams(authProperties.params)
        authPropertyParamsList = authProperties.params

        setEditAuthPropertyBody(false)
        setAuthPropertyBodyId('')
        setAuthPropertyBodyKey('')
        setAuthPropertyBodyValue('')
        setAuthProperBody(authProperties.body)
        authPropertyBodyList = authProperties.body


        setEditAuthPropertyResponse(false)
        setAuthPropertyResponseId('')
        setAuthPropertyResponseKey('')
        setAuthPropertyResponseValue('')
        setAuthProperResponse(authProperties.response)
        authPropertyResponseList = authProperties.response

      } else {
        setIsAuth(false)
        setShowAuthProperties(false)
        if(document.getElementById("isAuth")!= null){
          document.getElementById("isAuth").checked = false;
        }
        setAuthProperUrl('')
        setAuthProperMethod('')
        setAuthProperType('')

        setEditAuthPropertyHeader(false)
        setAuthPropertyHeaderId('')
        setAuthPropertyHeaderKey('')
        setAuthPropertyHeaderValue('')
        setAuthProperHeader([])
        authPropertyHeaderList = []

        setEditAuthPropertyParams(false)
        setAuthPropertyParamsId('')
        setAuthPropertyParamsKey('')
        setAuthPropertyParamsValue('')
        setAuthProperParams([])
        authPropertyParamsList = []

        setEditAuthPropertyBody(false)
        setAuthPropertyBodyId('')
        setAuthPropertyBodyKey('')
        setAuthPropertyBodyValue('')
        setAuthProperBody([])
        authPropertyBodyList = []

        setEditAuthPropertyResponse(false)
        setAuthPropertyResponseId('')
        setAuthPropertyResponseKey('')
        setAuthPropertyResponseValue('')
        setAuthProperResponse([])
        authPropertyResponseList = []
      }
    }

  }, [edit])

  // Mostrar la prescripcion de los usuarios
  const showUserPreinscription = async (value) => {

    setIsAuth(value)

    if (value) {
      setShowAuthProperties(true)
    } else {
      setShowAuthProperties(false)
    }
  }


  // Mostrar la prescripcion de los usuarios
  const showPreinscriptionDetailValue = async (value) => {

    setAuthProperType(value)


    if (value == 'Consultar Usuarios') {
      setShowPreInscripctionDetail(true)
    } else {
      setShowPreInscripctionDetail(false)
    }


  }


  // Metodo para eliminar elementos de las configuraciones
  const cleanAllConfigurations = async () => {
    setAuthProperUrl('')
    setAuthProperMethod('')

    setEditAuthPropertyHeader(false)
    setAuthPropertyHeaderId('')
    setAuthPropertyHeaderKey('')
    setAuthPropertyHeaderValue('')
    setAuthProperHeader([])
    authPropertyHeaderList = []

    setEditAuthPropertyParams(false)
    setAuthPropertyParamsId('')
    setAuthPropertyParamsKey('')
    setAuthPropertyParamsValue('')
    setAuthProperParams([])
    authPropertyParamsList = []

    setEditAuthPropertyBody(false)
    setAuthPropertyBodyId('')
    setAuthPropertyBodyKey('')
    setAuthPropertyBodyValue('')
    setAuthProperBody([])
    authPropertyBodyList = []

    setEditAuthPropertyResponse(false)
    setAuthPropertyResponseId('')
    setAuthPropertyResponseKey('')
    setAuthPropertyResponseValue('')
    setAuthProperResponse([])
    authPropertyResponseList = []
  }

  // Actualizar las configuraciones del cada uno de los branch(Sucursal)
  const updateConfigurations = async () => {


    if (isAuth) {
      setAuthProperUrl(authProperUrl)
      setAuthProperMethod(authProperMethod)
      setAuthProperType(authProperType)

      if (authProperType == '') {
        alert('Obligatorio: Seleccione un tipo de Consulta')
        return null;
      }

      if (authProperType == 'Consultar Usuarios') {
        setShowPreInscripctionDetail(true)
        if (authProperUrl == '') {
          alert('Obligatorio: Ingrese el valor de URL')
          return null;
        }
        if (authProperType == '') {
          alert('Obligatorio: Seleccione el tipo de petición')
          return null;
        }
        if (authProperMethod == '') {
          alert('Obligatorio: Seleccione el método de la petición')
          return null;
        }
      } else {
        cleanAllConfigurations()
        setShowPreInscripctionDetail(false)
      }

    } else {
      cleanAllConfigurations()
    }

    await mutateAsyncUpdate({
      _id: id,
      type: 'update_branch_auth_properties',
      auth: isAuth,
      authProperties: {
        url: authProperUrl,
        method: authProperMethod,
        type: authProperType,
        authPropertiesHeader: authPropertyHeaderList.length > 0 ? authPropertyHeaderList : authProperHeader,
        authPropertiesParams: authPropertyParamsList.length > 0 ? authPropertyParamsList : authProperParams,
        authPropertiesBody: authPropertyBodyList.length > 0 ? authPropertyBodyList : authProperBody,
        authPropertiesResponse: authPropertyResponseList.length > 0 ? authPropertyResponseList : authProperResponse,
      },
    })

  }

  // Limpiar clave / valor header
  const cleanAuthPropertyHeader = () => {
    setEditAuthPropertyHeader(false)
    setAuthPropertyHeaderId('')
    setAuthPropertyHeaderKey('')
    setAuthPropertyHeaderValue('')
    document.getElementById("close-modal-auth-property-add-header").click()
  }

  // Agregar header items
  const authPropertyHeaderAddFunction = () => {

    setAuthPropertyHeaderKey(authPropertyHeaderKey)
    setAuthPropertyHeaderValue(authPropertyHeaderValue)

    if (authPropertyHeaderKey == '') {
      alert('Ingrese clave')
      return false
    }

    if (authPropertyHeaderValue == '') {
      alert('Ingrese valor')
      return false
    }

    authPropertyHeaderList = authProperHeader

    authPropertyHeaderList.push({
      key: authPropertyHeaderKey,
      value: authPropertyHeaderValue
    })
    setAuthProperHeader(authPropertyHeaderList)
    updateConfigurations()
    cleanAuthPropertyHeader()
  }

  // Editar header items
  const authPropertyHeaderEditFunction = () => {

    setAuthPropertyHeaderId(authPropertyHeaderId)
    setAuthPropertyHeaderKey(authPropertyHeaderKey)
    setAuthPropertyHeaderValue(authPropertyHeaderValue)

    if (authPropertyHeaderKey == '') {
      alert('Ingrese clave')
      return false
    }

    if (authPropertyHeaderValue == '') {
      alert('Ingrese valor')
      return false
    }

    authPropertyHeaderList = authProperHeader

    for (let i = 0; i < authPropertyHeaderList.length; i++) {

      if (authPropertyHeaderList[i]._id == authPropertyHeaderId) {
        authPropertyHeaderList[i].key = authPropertyHeaderKey
        authPropertyHeaderList[i].value = authPropertyHeaderValue
      }
    }

    setAuthProperHeader(authPropertyHeaderList)
    updateConfigurations()
    cleanAuthPropertyHeader()
  }

  // Eliminar header items
  var authPropertyHeaderDeleteFunction = (authPropertyHeaderIdValue) => {

    authPropertyHeaderList = authProperHeader
    let listDeleted = []

    for (let i = 0; i < authPropertyHeaderList.length; i++) {

      if (authPropertyHeaderList[i]._id != authPropertyHeaderIdValue) {

        listDeleted.push({
          _id: authPropertyHeaderList[i]._id,
          key: authPropertyHeaderList[i].key,
          value: authPropertyHeaderList[i].value
        })
      }
    }

    authPropertyHeaderList = listDeleted
    setAuthProperHeader(listDeleted)
    updateConfigurations()
    cleanAuthPropertyHeader()
  }

  // Metodo mostrar valores para editar de un header
  const showEditAuthPropertyHeader = (header) => {
    setEditAuthPropertyHeader(true)
    setAuthPropertyHeaderId(header._id)
    setAuthPropertyHeaderKey(header.key)
    setAuthPropertyHeaderValue(header.value)
  }

  // Limpiar clave / valor params
  const cleanAuthPropertyParams = () => {
    setEditAuthPropertyParams(false)
    setAuthPropertyParamsId('')
    setAuthPropertyParamsKey('')
    setAuthPropertyParamsValue('')
    document.getElementById("close-modal-auth-property-add-params").click()
  }

  // Agregar params items
  const authPropertyParamsAddFunction = () => {

    setAuthPropertyParamsKey(authPropertyParamsKey)
    setAuthPropertyParamsValue(authPropertyParamsValue)

    if (authPropertyParamsKey == '') {
      alert('Ingrese clave')
      return false
    }

    if (authPropertyParamsValue == '') {
      alert('Ingrese valor')
      return false
    }

    authPropertyParamsList = authProperParams

    authPropertyParamsList.push({
      key: authPropertyParamsKey,
      value: authPropertyParamsValue
    })
    setAuthProperParams(authPropertyParamsList)
    updateConfigurations()
    cleanAuthPropertyParams()
  }

  // Editar params items
  const authPropertyParamsEditFunction = () => {

    setAuthPropertyParamsId(authPropertyParamsId)
    setAuthPropertyParamsKey(authPropertyParamsKey)
    setAuthPropertyParamsValue(authPropertyParamsValue)

    if (authPropertyParamsKey == '') {
      alert('Ingrese clave')
      return false
    }

    if (authPropertyParamsValue == '') {
      alert('Ingrese valor')
      return false
    }

    authPropertyParamsList = authProperParams

    for (let i = 0; i < authPropertyParamsList.length; i++) {

      if (authPropertyParamsList[i]._id == authPropertyParamsId) {
        authPropertyParamsList[i].key = authPropertyParamsKey
        authPropertyParamsList[i].value = authPropertyParamsValue
      }
    }

    setAuthProperParams(authPropertyParamsList)
    updateConfigurations()
    cleanAuthPropertyParams()
  }

  // Eliminar params items
  const authPropertyParamsDeleteFunction = (authPropertyParamsIdValue) => {

    authPropertyParamsList = authProperParams
    let listDeleted = []

    for (let i = 0; i < authPropertyParamsList.length; i++) {

      if (authPropertyParamsList[i]._id != authPropertyParamsIdValue) {

        listDeleted.push({
          _id: authPropertyParamsList[i]._id,
          key: authPropertyParamsList[i].key,
          value: authPropertyParamsList[i].value
        })
      }
    }

    authPropertyParamsList = listDeleted
    setAuthProperParams(listDeleted)
    updateConfigurations()
    cleanAuthPropertyParams()
  }

  // Metodo mostrar valores para editar de un params
  const showEditAuthPropertyParams = (params) => {
    setEditAuthPropertyParams(true)
    setAuthPropertyParamsId(params._id)
    setAuthPropertyParamsKey(params.key)
    setAuthPropertyParamsValue(params.value)
  }

  // Limpiar clave / valor body
  const cleanAuthPropertyBody = () => {
    setEditAuthPropertyBody(false)
    setAuthPropertyBodyId('')
    setAuthPropertyBodyKey('')
    setAuthPropertyBodyValue('')
    document.getElementById("close-modal-auth-property-add-body").click()
  }

  // Agregar body items
  const authPropertyBodyAddFunction = () => {

    setAuthPropertyBodyKey(authPropertyBodyKey)
    setAuthPropertyBodyValue(authPropertyBodyValue)

    if (authPropertyBodyKey == '') {
      alert('Ingrese clave')
      return false
    }

    if (authPropertyBodyValue == '') {
      alert('Ingrese valor')
      return false
    }

    authPropertyBodyList = authProperBody

    authPropertyBodyList.push({
      key: authPropertyBodyKey,
      value: authPropertyBodyValue
    })
    setAuthProperBody(authPropertyBodyList)
    updateConfigurations()
    cleanAuthPropertyBody()
  }

  // Editar body items
  const authPropertyBodyEditFunction = () => {

    setAuthPropertyBodyId(authPropertyBodyId)
    setAuthPropertyBodyKey(authPropertyBodyKey)
    setAuthPropertyBodyValue(authPropertyBodyValue)

    if (authPropertyBodyKey == '') {
      alert('Ingrese clave')
      return false
    }

    if (authPropertyBodyValue == '') {
      alert('Ingrese valor')
      return false
    }

    authPropertyBodyList = authProperBody

    for (let i = 0; i < authPropertyBodyList.length; i++) {

      if (authPropertyBodyList[i]._id == authPropertyBodyId) {
        authPropertyBodyList[i].key = authPropertyBodyKey
        authPropertyBodyList[i].value = authPropertyBodyValue
      }
    }

    setAuthProperBody(authPropertyBodyList)
    updateConfigurations()
    cleanAuthPropertyBody()
  }

  // Eliminar body items
  const authPropertyBodyDeleteFunction = (authPropertyBodyIdValue) => {

    authPropertyBodyList = authProperBody
    let listDeleted = []

    for (let i = 0; i < authPropertyBodyList.length; i++) {

      if (authPropertyBodyList[i]._id != authPropertyBodyIdValue) {

        listDeleted.push({
          _id: authPropertyBodyList[i]._id,
          key: authPropertyBodyList[i].key,
          value: authPropertyBodyList[i].value
        })
      }
    }

    authPropertyBodyList = listDeleted
    setAuthProperBody(listDeleted)
    updateConfigurations()
    cleanAuthPropertyBody()
  }

  // Metodo mostrar valores para editar de un body
  const showEditAuthPropertyBody = (body) => {
    setEditAuthPropertyBody(true)
    setAuthPropertyBodyId(body._id)
    setAuthPropertyBodyKey(body.key)
    setAuthPropertyBodyValue(body.value)
  }

  // Limpiar clave / valor response
  const cleanAuthPropertyResponse = () => {
    setEditAuthPropertyResponse(false)
    setAuthPropertyResponseId('')
    setAuthPropertyResponseKey('')
    setAuthPropertyResponseValue('')
    document.getElementById("close-modal-auth-property-add-response").click()
  }

  // Agregar response items
  const authPropertyResponseAddFunction = () => {

    setAuthPropertyResponseKey(authPropertyResponseKey)
    setAuthPropertyResponseValue(authPropertyResponseValue)

    if (authPropertyResponseKey == '') {
      alert('Ingrese clave')
      return false
    }

    if (authPropertyResponseValue == '') {
      alert('Ingrese valor')
      return false
    }

    authPropertyResponseList = authProperResponse

    authPropertyResponseList.push({
      key: authPropertyResponseKey,
      value: authPropertyResponseValue
    })
    setAuthProperResponse(authPropertyResponseList)
    updateConfigurations()
    cleanAuthPropertyResponse()
  }

  // Editar response items
  const authPropertyResponseEditFunction = () => {

    setAuthPropertyResponseId(authPropertyResponseId)
    setAuthPropertyResponseKey(authPropertyResponseKey)
    setAuthPropertyResponseValue(authPropertyResponseValue)

    if (authPropertyResponseKey == '') {
      alert('Ingrese clave')
      return false
    }

    if (authPropertyResponseValue == '') {
      alert('Ingrese valor')
      return false
    }

    authPropertyResponseList = authProperResponse

    for (let i = 0; i < authPropertyResponseList.length; i++) {

      if (authPropertyResponseList[i]._id == authPropertyResponseId) {
        authPropertyResponseList[i].key = authPropertyResponseKey
        authPropertyResponseList[i].value = authPropertyResponseValue
      }
    }

    setAuthProperResponse(authPropertyResponseList)
    updateConfigurations()
    cleanAuthPropertyResponse()
  }

  // Eliminar response items
  const authPropertyResponseDeleteFunction = (authPropertyResponseIdValue) => {

    authPropertyResponseList = authProperResponse
    let listDeleted = []

    for (let i = 0; i < authPropertyResponseList.length; i++) {

      if (authPropertyResponseList[i]._id != authPropertyResponseIdValue) {

        listDeleted.push({
          _id: authPropertyResponseList[i]._id,
          key: authPropertyResponseList[i].key,
          value: authPropertyResponseList[i].value
        })
      }
    }

    authPropertyResponseList = listDeleted
    setAuthProperResponse(listDeleted)
    updateConfigurations()
    cleanAuthPropertyResponse()
  }

  // Metodo mostrar valores para editar de un response
  const showEditAuthPropertyResponse = (response) => {
    setEditAuthPropertyResponse(true)
    setAuthPropertyResponseId(response._id)
    setAuthPropertyResponseKey(response.key)
    setAuthPropertyResponseValue(response.value)
  }

  return (
    <div
      className='modal fade'
      id='branchModal'
      tabIndex='-1'
      aria-labelledby='branchModalLabel'
    >
      <div className='modal-dialog modal-dialog-grande'>
        <div className='modal-content modal-background'>
          <div className='modal-header'>
            <h3 className='modal-title ' id='branchModalLabel'>
              {edit ? 'Editar Sucursal' : 'Agregar Sucursal'}
            </h3>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={formCleanHandler}
            ></button>
          </div>
          <div className='modal-body'>
            {errorUpdate ? <Message variant='danger'>{errorUpdate}</Message> : ''}

            {errorUpload ? <Message variant='danger'>{errorUpload}</Message> : ''}
            {isError ? <Message variant='danger'>{isError}</Message> : ''}
            {isSuccessUpdate && dataSuccessUpdate.toString().indexOf("[{") == -1  ? <Message variant='success'>{dataSuccessUpdate}</Message> : ''}

            <form onSubmit={handleSubmit(submitHandler)}>

              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link active" id="icon-tab-0" data-bs-toggle="tab" href="#icon-tabpanel-0" role="tab" aria-controls="icon-tabpanel-0" aria-selected="true"><AiOutlineApartment /> Datos de la Sucursal</a>
                </li>
                <li className="nav-item" role="presentation" style={{ display: edit === true ? 'block' : 'none' }}>
                  <a className="nav-link" id="icon-tab-1" data-bs-toggle="tab" href="#icon-tabpanel-1" role="tab" aria-controls="icon-tabpanel-1" aria-selected="false"><AiOutlineAppstoreAdd onClick={formCleanHandler} /> Abonados Principales </a>
                </li>
                <li className="nav-item" role="presentation" style={{ display: edit === true ? 'block' : 'none' }}>
                  <a className="nav-link" id="icon-tab-2" data-bs-toggle="tab" href="#icon-tabpanel-2" role="tab" aria-controls="icon-tabpanel-2" aria-selected="false"><AiOutlineTeam /> Administradores de Sucursal</a>
                </li>

                {isSuperAdmin ? (
                  <li className="nav-item" role="presentation" style={{ display: edit === true ? 'block' : 'none' }}>
                    <a className="nav-link" id="icon-tab-3" data-bs-toggle="tab" href="#icon-tabpanel-3" role="tab" aria-controls="icon-tabpanel-3" aria-selected="false"><AiOutlineFileDone /> Contrato</a>
                  </li>) : ''}

                {isSuperAdmin ? (
                  <li className="nav-item" role="presentation" style={{ display: edit === true ? 'block' : 'none' }}>
                    <a className="nav-link" id="icon-tab-4" data-bs-toggle="tab" href="#icon-tabpanel-4" role="tab" aria-controls="icon-tabpanel-4" aria-selected="false" ><AiOutlineGlobal /> Mi Ubicación</a>
                  </li>) : ''}

                {isAuth && authProperType == 'Consultar Usuarios Alerta' ? (
                  <li className="nav-item" role="presentation" style={{ display: edit === true ? 'block' : 'none' }}>
                    <a className="nav-link" id="icon-tab-5" data-bs-toggle="tab" href="#icon-tabpanel-5" role="tab" aria-controls="icon-tabpanel-5" aria-selected="false" ><AiOutlineUsergroupAdd /> Preinscripción Usuarios</a>
                  </li>) : ''}

                {isSuperAdmin ? (
                  <li className="nav-item" role="presentation" style={{ display: edit === true ? 'block' : 'none' }}>
                    <a className="nav-link" id="icon-tab-6" data-bs-toggle="tab" href="#icon-tabpanel-6" role="tab" aria-controls="icon-tabpanel-6" aria-selected="false" ><AiOutlineSetting /> Configuraciones</a>
                  </li>) : ''}

              </ul>

              <div className="tab-content pt-3" id="tab-content">
                <div className="tab-pane active" id="icon-tabpanel-0" role="tabpanel" aria-labelledby="icon-tab-0">

                  <div className='row'>
                    <div className='col-md-6'>
                      {inputText({
                        register,
                        errors,
                        label: 'Nombre:',
                        name: 'name',
                        placeholder: 'Nombre',
                      })}
                    </div>
                    <div className='col-md-6'>
                      <label htmlFor='isPublic'><b>Visibilidad:</b></label>
                      {inputCheckBox({
                        register,
                        errors,
                        watch,
                        name: 'isPublic',
                        label: 'Es Público?',
                        isRequired: false,
                        placeholder: 'Es Público?',
                      })}
                    </div>
                    <div className='col-md-6'>
                      <label htmlFor='active'><b>Estado</b></label>
                      {inputCheckBox({
                        register,
                        errors,
                        watch,
                        name: 'active',
                        label: 'Activo',
                        isRequired: false,
                        placeholder: 'Activo',
                      })}
                    </div>
                  </div>

                  <div className='row'>
                    <div className="col-md-5">

                    </div>
                    <div className="col-md-2">
                      <button type='submit' className='btn btn-primary form-control' data-bs-dismiss='modal' disabled={isLoadingPost}>
                        <AiOutlineEdit /> &nbsp; {isLoadingPost ? (
                          <span className='spinner-border spinner-border-sm' />
                        ) : (
                          edit ? 'Actualizar' : 'Crear '
                        )}
                      </button>
                    </div>
                    <div className="col-md-5">

                    </div>
                  </div>

                </div>
                <div className="tab-pane" id="icon-tabpanel-1" role="tabpanel" aria-labelledby="icon-tab-1">

                  <div>
                    <center>
                      <a className="btn btn-primary" href="#open-modal-member" onClick={() => cleanMember()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Agregar un Abonado Principal"> <AiOutlineUserAdd /> &nbsp;Agregar un Abonado Principal</a>
                      &nbsp;
                      <label htmlFor="uploadFile" className="btn btn-primary btn-block btn-outlined" data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Subir Abonados Principales">
                        {isLoadingUpload ? (
                          <span className='spinner-border spinner-border-sm' />
                        ) : (
                          ''
                        )}
                        <AiOutlineUpload /> &nbsp; Subir Abonado Principal
                      </label>
                      <input id="uploadFile" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFileChange} onClick={(e) => { e.target.value = null }} className='form-control' style={{ display: 'none' }} />
                      &nbsp;
                      <a href="#open-modal-upload-members" className='btn btn-primary btn-sm rounded-pill' data-bs-toggle="tooltip" data-bs-placement="top" title="Clic Pasos para Subir Abonados Principales" >
                        <FaQuestion />
                      </a>
                      &nbsp;
                      <a className="btn btn-primary" onClick={() => generateReportUsers()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Descargar Listado Abonados Principales"> <AiOutlineFileExcel /> &nbsp;Listado Abonados Principales</a>
                    </center>
                    <div id="open-modal-upload-members" className="modal-window-internal">
                      <div>
                        <b><h5 >Manual para subir múltiples abonados principales por Sucursal </h5></b>
                        <a href="#" title="Close" className="modal-close">&#x2715;</a>
                        <hr></hr>
                        <ol type="1">
                          <li>Descargar la siguiente plantilla de Excel para la la subida de abonados principales <a href={process.env.PUBLIC_URL + "/PlantillaMiembros.xlsx"} download={"Plantilla abonados.xlsx"} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para descargar plantilla para subir abonados principales" >Plantilla</a></li>
                          <li>Llenar las columnas con la información. Las columnas con color verde es información requerida</li>
                          <li>Dar clic en el botón <b>Subir Abonados Principales</b> y seleccionar el archivo. Esperamos a que se realice el respectivo proceso</li>
                          <li>Se descarga un archivo con la información del procesamiento de cada uno de los abonados principales agregados o cuales tengan problemas</li>
                        </ol>


                      </div>
                    </div>
                    <br></br>
                  </div>

                  <DatatableWrapper body={members} headers={headers} paginationOptionsProps={{
                    initialState: {
                      rowsPerPage: 15,
                      options: [5, 10, 15, 20]
                    }
                  }} >
                    <Row className="mb-4">
                      <Col
                        xs={12}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                      >
                        <Filter placeholder={'Ingrese información del abonado a encontrar'} />
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
                      >
                        <PaginationOptions labels={{ beforeSelect: `Filas por página / Abonados encontrados ${members.length}` }} />
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                      >
                        <Pagination labels={{ firstPage: 'Inicio', lastPage: 'Final', nextPage: 'Siguiente', prevPage: 'Anterior' }} />
                      </Col>
                    </Row>
                    <hr></hr>
                    <Table>
                      <TableHeader />
                      <TableBody>
                        {(rows) =>
                          rows.length === 0 ? (
                            <EmptyTablePlaceholder noResultsLabel={'Usuarios no encontrados'} />
                          ) : (
                            rows.map((rowData, rowIdx) => (
                              <tr key={rowIdx} className='text-center'>
                                <td>{rowData.name} {rowData.lastname}</td>
                                <td>
                                  {rowData.active ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )}

                                </td>
                                <td>{rowData.identification}</td>
                                <td>
                                  {rowData.accountValidationPhoneToken == '' ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )} &nbsp;&nbsp;{rowData.phone}
                                </td>
                                <td>
                                  {rowData.accountValidationEmailToken == '' ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )}&nbsp;&nbsp;{rowData.email}
                                </td>
                                <td>
                                  {rowData.accountValidationInitialPasswordToken == undefined ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )}
                                </td>
                                <td>
                                  {rowData.blocked ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )}
                                </td>

                                <td>
                                  <div className='btn-group'>

                                    <a className="btn btn-primary btn-sm rounded-pill" href="#open-modal-member" onClick={() => editMemberFunction(rowData._id)} data-bs-toggle="tooltip" data-bs-placement="top" title="Editar Abonado Principal"> <FaPenAlt /></a>
                                    &nbsp;
                                    <button className='btn btn-danger btn-sm ms-1 rounded-pill' onClick={() => { if (window.confirm('Desea eliminar el abonado principal de la Sucursal ?')) deleteMemberFunction(rowData._id) }} data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar Abonado Principal">
                                      <span><FaTrash /></span>
                                    </button>
                                    &nbsp;


                                  </div>
                                </td>
                              </tr>

                            )
                            )
                          )
                        }
                      </TableBody>
                    </Table>
                  </DatatableWrapper>

                  <div id="open-modal-member" className="modal-window-internal" style={{ top: '10px' }}>
                    <div>
                      <b><h5 >
                        {editMember ? 'Editar Abonado Principal' : 'Agregar Abonado Principal'}
                      </h5></b>
                      <a href="#" id="close-branch-member" title="Close" className="modal-close" onClick={() => cleanMember()}>&#x2715;</a>
                      <hr></hr>
                      <ul className="nav nav-tabs" role="tablist">
                        <li className="nav-item" role="presentation">
                          <a className="nav-link active" id="icon-tab-user-0" data-bs-toggle="tab" href="#icon-tabpanel-user-0" role="tab" aria-controls="icon-tabpanel-user-0" aria-selected="true"><AiOutlineApartment /> Datos del Abonado Principal</a>
                        </li>
                        <li className="nav-item" role="presentation" style={{ display: editMember === true ? 'block' : 'none' }}>
                          <a className="nav-link" id="icon-tab-user-1" data-bs-toggle="tab" href="#icon-tabpanel-user-1" role="tab" aria-controls="icon-tabpanel-user-1" aria-selected="false"><AiOutlineAppstoreAdd /> Redes del Abonado Principal </a>
                        </li>


                      </ul>

                      <div className="tab-content pt-3" id="tab-content">

                        <div className="tab-pane active" id="icon-tabpanel-user-0" role="tabpanel" aria-labelledby="icon-tab-user-0">

                          <div className='row'>
                            <div className="col-md-12">

                              {editMember == false ? (

                                <div className='row'>
                                  <div className="row">
                                    <div className="col-md-2">
                                      <label><b>Búsqueda:</b></label>
                                    </div>
                                    <div className="col-md-8">
                                      <input
                                        type='text'
                                        name='inputSearchMember'
                                        placeholder='Usuarios por identificación, email o teléfono'
                                        value={inputSearchMember}
                                        style={({ width: '100%' })}
                                        onChange={(event) => setInputSearchMember(event.target.value)}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <span className="d-inline-block" tabIndex="0" data-bs-toggle="tooltip" title="Buscar">
                                        <button type='button' className='btn btn-primary btn-sm rounded-pill'
                                          onClick={() => formValidationSearchMember()}>
                                          <FaSearch />
                                        </button>
                                      </span>
                                      &nbsp;
                                      <span className="d-inline-block" tabIndex="0" data-bs-toggle="tooltip" title="Limpiar">
                                        <button className='btn btn-primary btn-sm rounded-pill'
                                          onClick=
                                          {() => cleanMember()}>
                                          <FaBroom />
                                        </button>
                                      </span>
                                    </div>
                                  </div>
                                  &nbsp;
                                  <div className='row text-center'>
                                    {errorsListMember ? (<span className='text-danger'>{errorsListMember}</span>) : ''}
                                  </div>
                                  <br></br>
                                  <hr></hr>
                                </div>

                              ) : ''}

                            </div>
                          </div>

                          <div className='row'>
                            {editMember ? (
                              <div className="col-md-12">

                                <div className="alert alert-primary text-center" role="alert">
                                  Editar un usuario solo se puede realizar desde el perfil de cada usuario
                                </div>
                              </div>) : ''}

                            {editMember == false ? (
                              <div className="col-md-6">
                                <label htmlFor="typeIdentificationMember"><b>Tipo Identificación:</b></label>
                                <select onChange={(event) => setTypeIdentificationMember(event.target.value)} disabled={isDisabledMember}
                                  name='typeIdentificationMember' className='form-control' value={typeIdentificationMember}>
                                  <option key="" >Seleccione una opción</option>
                                  <option key="RUC" >RUC</option>
                                  <option key="Cedula" >Cedula</option>
                                  <option key="Pasaporte" >Pasaporte</option>
                                </select>
                              </div>) : (
                              <div className="col-md-6">
                                <label><b>Tipo Identificación:</b></label><br></br>
                                <label>{typeIdentificationMember == '' ? 'No ha ingresado' : typeIdentificationMember}</label>
                                <br></br>
                              </div>)}

                            {editMember == false ? (
                              <div className="col-md-6">
                                <label htmlFor="identificationMember"><b>Identificación:</b></label>
                                <input
                                  type='text'
                                  name='identificationMember'
                                  value={identificationMember}
                                  onChange={(event) => setIdentificationMember(event.target.value)}
                                  className='form-control'
                                  disabled={isDisabledMember}
                                />
                              </div>) : (
                              <div className="col-md-6">
                                <label><b>Identificación:</b></label><br></br>
                                <label>{identificationMember == '' ? 'No ha ingresado' : identificationMember}</label>
                                <br></br>
                              </div>)}

                            {editMember == false ? (
                              <div className="col-md-6">
                                <label htmlFor="nameMember"><b>Nombres:</b></label>
                                <input
                                  type='text'
                                  name='nameMember'
                                  value={nameMember}
                                  onChange={(event) => setNameMember(event.target.value)}
                                  className='form-control'
                                  disabled={isDisabledMember}
                                />
                              </div>) : (
                              <div className="col-md-6">
                                <label><b>Nombres:</b></label><br></br>
                                <label>{nameMember == '' ? 'No ha ingresado' : nameMember}</label>
                                <br></br>
                              </div>)}

                            {editMember == false ? (
                              <div className="col-md-6">
                                <label htmlFor="lastNameMember"><b>Apellidos:</b></label>
                                <input
                                  type='text'
                                  name='lastNameMember'
                                  value={lastNameMember}
                                  onChange={(event) => setLastNameMember(event.target.value)}
                                  className='form-control'
                                  disabled={isDisabledMember}
                                />
                              </div>) : (
                              <div className="col-md-6">
                                <label><b>Apellidos:</b></label><br></br>
                                <label>{lastNameMember == '' ? 'No ha ingresado' : lastNameMember}</label>
                                <br></br>
                              </div>)}

                            {editMember == false ? (
                              <div className="col-md-6">
                                <label htmlFor="emailMember"><b>Correo Electrónico:</b></label>
                                <input
                                  type='email'
                                  name='emailMember'
                                  value={emailMember}
                                  onChange={(event) => setEmailMember(event.target.value)}
                                  className='form-control'
                                  disabled={isDisabledMember}
                                />
                              </div>) : (
                              <div className="col-md-6">
                                <label><b>Correo Electrónico:</b></label><br></br>
                                <label>{emailMember == '' ? 'No ha ingresado' : emailMember}</label>
                                <br></br>
                              </div>)}

                            {(validationPhone != "" || editMember == false )? (
                              <div className="col-md-6">
                                <label htmlFor="phoneNumberMember"><b>Teléfono:</b></label>
                                <PhoneInput
                                  name="phoneNumberMember"
                                  placeholder="Ingrese un número telefónico"
                                  value={phoneNumberMember}
                                  onChange={setPhoneNumberMember}
                                  className='form-control'
                                />
                              </div>) : (
                              <div className="col-md-6">
                                <label><b>Teléfono:</b></label><br></br>
                                <label>{phoneNumberMember == '' ? 'No ha ingresado' : phoneNumberMember}</label>
                                <br></br>
                              </div>)}

                            {editMember == false ? (
                              <div className="col-md-6">
                                <label htmlFor="sexMember"><b>Sexo:</b></label>
                                <select onChange={(event) => setSexMember(event.target.value)} disabled={isDisabledMember}
                                  name='sexMember' className='form-control' value={sexMember}>
                                  <option key="" >Seleccione una opción</option>
                                  <option key="Masculino" >Masculino</option>
                                  <option key="Femenino" >Femenino</option>
                                </select>
                              </div>) : (
                              <div className="col-md-6">
                                <label><b>Sexo:</b></label><br></br>
                                <label>{sexMember == '' ? 'No ha ingresado' : sexMember}</label>
                                <br></br>
                              </div>)}


                            {editMember == false ? (
                              <div className="col-md-6">
                                <label htmlFor="birthdayMember"><b>F. Nacimiento:</b></label>
                                <input
                                  type='date'
                                  name='birthdayMember'
                                  value={birthdayMember}
                                  onChange={(event) => setBirthdayMember(event.target.value)}
                                  className='form-control'
                                  disabled={isDisabledMember}
                                />
                              </div>) : (
                              <div className="col-md-6">
                                <label><b>F. Nacimiento:</b></label><br></br>
                                <label>{birthdayMember == '' ? 'No ha ingresado' : birthdayMember}</label>
                                <br></br>
                              </div>)}
                          </div>

                          {editMember ? (<hr></hr>) : ''}

                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="isActiveMember"><b>Estado:</b></label>
                              <div className='form-check form-switch form-control'>
                                <input className='form-check-input'
                                  type='checkbox'
                                  id='isActiveMember'
                                  name='isActiveMember'
                                  value={isActiveMember}
                                  onChange={(event) => setIsActiveMember(event.target.checked)}
                                  disabled={isDisabledMemberEdit}
                                />
                                <label className='form-check-label' htmlFor='isActiveMember'>
                                  Activo
                                </label>
                              </div>
                            </div>

                            <div className='row'>&nbsp;</div>
                            <div className='row'>
                              <div className="col-md-4">
                                <p style={({ display: 'none' })}>{idMember}</p>
                              </div>
                              <div className="col-md-4">
                                <button type='button' onClick={() => addMember()} className='btn btn-primary form-control' disabled={isDisabledMemberEdit} data-bs-toggle="tooltip" data-bs-placement="top" title={isDisabledUserEdit == false ? ' Actualizar Abonado Principal ' : ' Crear Abonado Principal'}>
                                  <AiOutlineUserAdd /> &nbsp;

                                  {isLoadingBranch ? (
                                    <span className='spinner-border spinner-border-sm' />
                                  ) : ('')}

                                  {editMember ? 'Actualizar' : 'Crear '}
                                </button>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div className="tab-pane" id="icon-tabpanel-user-1" role="tabpanel" aria-labelledby="icon-tab-user-1">
                          <iframe id='iframeNetworks' src={`/admin/auth/networks?network_id=${networkMember}&branch_id=${id}` + ' '} width="100%" height="460px"  >

                          </iframe>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
                <div className="tab-pane" id="icon-tabpanel-2" role="tabpanel" aria-labelledby="icon-tab-2" >

                  <center><a className="btn btn-primary" href="#open-modal-user" onClick={() => cleanUser()} data-bs-toggle="tooltip" data-bs-placement="top" title="Agregar un usuario con roles Administrativos en la sucursal" > <AiOutlineUserAdd /> &nbsp;Agregar un Usuario</a></center>
                  <br></br>

                  <DatatableWrapper body={users} headers={headersUsers} paginationOptionsProps={{
                    initialState: {
                      rowsPerPage: 15,
                      options: [5, 10, 15, 20]
                    }
                  }} >
                    <Row className="mb-4">
                      <Col
                        xs={12}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                      >
                        <Filter placeholder={'Ingrese información del usuario a encontrar'} />
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
                      >
                        <PaginationOptions labels={{ beforeSelect: `Filas por página / Usuarios encontrados ${users.length}` }} />
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                      >
                        <Pagination labels={{ firstPage: 'Inicio', lastPage: 'Final', nextPage: 'Siguiente', prevPage: 'Anterior' }} />
                      </Col>
                    </Row>
                    <hr></hr>
                    <Table>
                      <TableHeader />
                      <TableBody>
                        {(rows) =>
                          rows.length === 0 ? (
                            <EmptyTablePlaceholder noResultsLabel={'Usuarios no encontrados'} />
                          ) : (
                            rows.map((rowData, rowIdx) => (
                              <tr key={rowIdx} className='text-center'>
                                <td>{rowData.name} {rowData.lastname}</td>
                                <td>
                                  {rowData.active ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )}

                                </td>
                                <td>{rowData.role}</td>
                                <td>{rowData.identification}</td>
                                <td>
                                  {rowData.accountValidationPhoneToken == '' ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )} &nbsp;&nbsp;{rowData.phone}
                                </td>
                                <td>
                                  {rowData.accountValidationEmailToken == '' ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )}&nbsp;&nbsp;{rowData.email}
                                </td>
                                <td>
                                  {rowData.accountValidationInitialPasswordToken == undefined ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )}
                                </td>
                                <td>
                                  {rowData.blocked ? (
                                    <FaCheckCircle className='text-success' />
                                  ) : (
                                    <FaTimesCircle className='text-danger' />
                                  )}
                                </td>
                                <td>
                                  <div className='btn-group'>

                                    <a className="btn btn-primary btn-sm rounded-pill" href="#open-modal-user" onClick={() => editUserFunction(rowData._id)} data-bs-toggle="tooltip" data-bs-placement="top" title="Editar Usuario"> <FaPenAlt /></a>
                                    &nbsp;
                                    <button className='btn btn-danger btn-sm ms-1 rounded-pill' data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar Usuario con Rol Administrativo de Sucursal" onClick={() => { if (window.confirm('Desea eliminar el usuario de admistradores de la Sucursal ?')) deleteUserFunction(rowData._id) }}>
                                      <span><FaTrash /></span>
                                    </button>

                                  </div>
                                </td>
                              </tr>

                            )
                            )
                          )
                        }
                      </TableBody>
                    </Table>
                  </DatatableWrapper>


                  <div id="open-modal-user" className="modal-window-internal">
                    <div>
                      <b><h5 >
                        {editUser ? 'Editar Usuario' : 'Agregar Usuario'}
                      </h5></b>
                      <a href="#" id="close-user-branch" title="Close" className="modal-close">&#x2715;</a>
                      <hr></hr>
                      <div className='row'>
                        <div className="col-md-12">

                          {editUser == false ? (
                            <div className='row'>
                              <div className="row">
                                <div className="col-md-2">
                                  <label><b>Búsqueda:</b></label>
                                </div>
                                <div className="col-md-8">
                                  <input
                                    type='text'
                                    name='inputSearchUser'
                                    placeholder='Usuarios por identificación, email o teléfono'
                                    value={inputSearchUser}
                                    style={({ width: '100%' })}
                                    onChange={(event) => setInputSearchUser(event.target.value)}
                                  />
                                </div>
                                <div className="col-md-2">
                                  <span className="d-inline-block" tabIndex="0" data-bs-toggle="tooltip" title="Buscar">
                                    <button type='button' className='btn btn-primary btn-sm rounded-pill'
                                      onClick={() => formValidationSearchUser()}>
                                      <FaSearch />
                                    </button>
                                  </span>
                                  &nbsp;
                                  <span className="d-inline-block" tabIndex="0" data-bs-toggle="tooltip" title="Limpiar">
                                    <button className='btn btn-primary btn-sm rounded-pill'
                                      onClick=
                                      {() => cleanUser()}>
                                      <FaBroom />
                                    </button>
                                  </span>
                                </div>
                              </div>
                              &nbsp;
                              <div className='row text-center'>
                                {errorsListUser ? (<span className='text-danger'>{errorsListUser}</span>) : ''}
                              </div>
                              <br></br>
                              <hr></hr>
                            </div>

                          ) : ''}

                        </div>
                      </div>

                      <div className='row'>

                        {editUser ? (
                          <div className="col-md-12">

                            <div className="alert alert-primary text-center" role="alert">
                              Editar un usuario solo se puede realizar desde el perfil de cada usuario
                            </div>
                          </div>) : ''}
                        {editUser == false ? (
                          <div className="col-md-6">
                            <label htmlFor="typeIdentificationUser"><b>Tipo Identificación:</b></label>
                            <select onChange={(event) => setTypeIdentificationUser(event.target.value)} disabled={isDisabledUser}
                              name='typeIdentificationUser' className='form-control' value={typeIdentificationUser}>
                              <option value="" >Seleccione una opción</option>
                              <option value="RUC" >RUC</option>
                              <option value="Cedula" >Cedula</option>
                              <option value="Pasaporte" >Pasaporte</option>
                            </select>
                          </div>) : (
                          <div className="col-md-6">
                            <label><b>Tipo Identificación:</b></label><br></br>
                            <label>{typeIdentificationUser == '' ? 'No ha ingresado' : typeIdentificationUser}</label>
                            <br></br>
                          </div>)}

                        {editUser == false ? (
                          <div className="col-md-6">
                            <label htmlFor="identificationUser"><b>Identificación:</b></label>
                            <input
                              type='text'
                              name='identificationUser'
                              value={identificationUser}
                              onChange={(event) => setIdentificationUser(event.target.value)}
                              className='form-control'
                              disabled={isDisabledUser}
                            />
                          </div>) : (
                          <div className="col-md-6">
                            <label><b>Identificación:</b></label><br></br>
                            <label>{identificationUser == '' ? 'No ha ingresado' : identificationUser}</label>
                            <br></br>
                          </div>)}

                        {editUser == false ? (
                          <div className="col-md-6">
                            <label htmlFor="nameUser"><b>Nombres:</b></label>
                            <input
                              type='text'
                              name='nameUser'
                              value={nameUser}
                              onChange={(event) => setNameUser(event.target.value)}
                              className='form-control'
                              disabled={isDisabledUser}
                            />
                          </div>) : (
                          <div className="col-md-6">
                            <label><b>Nombres:</b></label><br></br>
                            <label>{nameUser == '' ? 'No ha ingresado' : nameUser}</label>
                            <br></br>
                          </div>)}

                        {editUser == false ? (
                          <div className="col-md-6">
                            <label htmlFor="lastNameUser"><b>Apellidos:</b></label>
                            <input
                              type='text'
                              name='lastNameUser'
                              value={lastNameUser}
                              onChange={(event) => setLastNameUser(event.target.value)}
                              className='form-control'
                              disabled={isDisabledUser}
                            />
                          </div>) : (
                          <div className="col-md-6">
                            <label><b>Apellidos:</b></label><br></br>
                            <label>{lastNameUser == '' ? 'No ha ingresado' : lastNameUser}</label>
                            <br></br>
                          </div>)}

                        {editUser == false ? (
                          <div className="col-md-6">
                            <label htmlFor="emailUser"><b>Correo Electrónico:</b></label>
                            <input
                              type='email'
                              name='emailUser'
                              value={emailUser}
                              onChange={(event) => setEmailUser(event.target.value)}
                              className='form-control'
                              disabled={isDisabledUser}
                            />
                          </div>) : (
                          <div className="col-md-6">
                            <label><b>Correo Electrónico:</b></label><br></br>
                            <label>{emailUser == '' ? 'No ha ingresado' : emailUser}</label>
                            <br></br>
                          </div>)}

                        {editUser == false ? (
                          <div className="col-md-6">
                            <label htmlFor="phoneNumberUser"><b>Teléfono:</b></label>
                            <PhoneInput
                              name="phoneNumberUser"
                              placeholder="Ingrese un número telefónico"
                              value={phoneNumberUser}
                              onChange={setPhoneNumberUser}
                              className='form-control'
                              disabled={isDisabledUser}
                            />
                          </div>) : (
                          <div className="col-md-6">
                            <label><b>Teléfono:</b></label><br></br>
                            <label>{phoneNumberUser == '' ? 'No ha ingresado' : phoneNumberUser}</label>
                            <br></br>
                          </div>)}

                        {editUser == false ? (
                          <div className="col-md-6">
                            <label htmlFor="sexUser"><b>Sexo:</b></label>
                            <select onChange={(event) => setSexUser(event.target.value)} disabled={isDisabledUser}
                              name='sexUser' className='form-control' value={sexUser}>
                              <option value="" >Seleccione una opción</option>
                              <option value="Masculino" >Masculino</option>
                              <option value="Femenino" >Femenino</option>
                            </select>
                          </div>) : (
                          <div className="col-md-6">
                            <label><b>Sexo:</b></label><br></br>
                            <label>{sexUser == '' ? 'No ha ingresado' : sexUser}</label>
                            <br></br>
                          </div>)}

                        {editUser == false ? (
                          <div className="col-md-6">
                            <label htmlFor="birthdayUser"><b>F. Nacimiento:</b></label>
                            <input
                              type='date'
                              name='birthdayUser'
                              value={birthdayUser}
                              onChange={(event) => setBirthdayUser(event.target.value)}
                              className='form-control'
                              disabled={isDisabledUser}
                            />
                          </div>) : (
                          <div className="col-md-6">
                            <label><b>F. Nacimiento:</b></label><br></br>
                            <label>{birthdayUser == '' ? 'No ha ingresado' : birthdayUser}</label>
                            <br></br>
                          </div>)}
                      </div>
                      {editUser ? (<hr></hr>) : ''}

                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="roleUser"><b>Rol:</b></label>
                          <select onChange={(event) => setRoleUser(event.target.value)} disabled={isDisabledUserEdit}
                            name='roleUser' className='form-control' value={roleUser}>
                            <option value="" >Seleccione una opción</option>
                            <option value="ADMIN_BRANCH" >Admin</option>
                            <option value="MONITOR_BRANCH" >Monitor</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="isActiveUser"><b>Estado:</b></label>
                          <div className='form-check form-switch form-control'>
                            <input className='form-check-input'
                              type='checkbox'
                              id='isActiveUser'
                              name='isActiveUser'
                              value={isActiveUser}
                              onChange={(event) => setIsActiveUser(event.target.checked)}
                              disabled={isDisabledUserEdit}
                            />
                            <label className='form-check-label' htmlFor='isActiveUser'>
                              Activo
                            </label>
                          </div>
                        </div>
                        <div className='row'>&nbsp;</div>
                        <div className='row col-md-12'>
                          <div className="col-md-4">
                            <p style={({ display: 'none' })}>{idUser}</p>
                          </div>
                          <div className="col-md-4">
                            <button type='button' onClick={addUser} className='btn btn-primary form-control' disabled={isDisabledUserEdit} data-bs-toggle="tooltip" data-bs-placement="top" title="Actualizar Organización" >
                              <AiOutlineUserAdd /> &nbsp;

                              {isLoadingBranch ? (
                                <span className='spinner-border spinner-border-sm' />
                              ) : ('')}

                              {isDisabledUserEdit == false ? ' Actualizar' : ' Crear '}

                            </button>
                          </div>
                          <div className="col-md-4">

                          </div>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>

                {isSuperAdmin ? (
                  <div className="tab-pane" id="icon-tabpanel-3" role="tabpanel" aria-labelledby="icon-tab-3">
                    <iframe src={`/admin/auth/branch-licenses?branch_id=${id}`} width="100%" height="1200px"  ></iframe>
                  </div>) : ''}

                {isSuperAdmin ? (
                  <div className="tab-pane" id="icon-tabpanel-4" role="tabpanel" aria-labelledby="icon-tab-4">
                    <div className="row">

                      <iframe src={`/admin/auth/branches-maps?branch_id=${id}&latitude_branch=${latitudeBranch}&longitude_branch=${longitudeBranch}&radius_branch=${radiusBranch}`} width="100%" height="1200px"  ></iframe>

                    </div>
                  </div>) : ''}

                {isAuth && authProperType == 'Consultar Usuarios Alerta' ? (
                  <div className="tab-pane" id="icon-tabpanel-5" role="tabpanel" aria-labelledby="icon-tab-5" >

                    <center>
                      <label htmlFor="uploadFileBranchUser" className="btn btn-primary btn-block btn-outlined" data-bs-toggle="tooltip" data-bs-placement="top" title="Subir Usuarios desde un archivo Excel">
                        {isLoadingUpload ? (
                          <span className='spinner-border spinner-border-sm' />
                        ) : (
                          ''
                        )}
                        <AiOutlineUpload /> &nbsp; Subir Usuarios
                      </label>
                      <input id="uploadFileBranchUser" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFileChangeBranchUser} onClick={(e) => { e.target.value = null }} className='form-control' style={{ display: 'none' }} />
                      &nbsp;
                      <a className="btn btn-primary" href="#open-modal-branch-user" onClick={() => createBranchUserFunction()} data-bs-toggle="tooltip" data-bs-placement="top" title="Agregar un usuario" > <AiOutlineUserAdd /> &nbsp;Agregar un Usuario</a>
                    </center>
                    <br></br>

                    <DatatableWrapper body={branchUsers} headers={headersBranchUsers} paginationOptionsProps={{
                      initialState: {
                        rowsPerPage: 15,
                        options: [5, 10, 15, 20]
                      }
                    }} >
                      <Row className="mb-4">
                        <Col
                          xs={12}
                          lg={4}
                          className="d-flex flex-col justify-content-end align-items-end"
                        >
                          <Filter placeholder={'Ingrese información del usuario a encontrar'} />
                        </Col>
                        <Col
                          xs={12}
                          sm={6}
                          lg={4}
                          className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
                        >
                          <PaginationOptions labels={{ beforeSelect: `Filas por página / Usuarios encontrados ${users.length}` }} />
                        </Col>
                        <Col
                          xs={12}
                          sm={6}
                          lg={4}
                          className="d-flex flex-col justify-content-end align-items-end"
                        >
                          <Pagination labels={{ firstPage: 'Inicio', lastPage: 'Final', nextPage: 'Siguiente', prevPage: 'Anterior' }} />
                        </Col>
                      </Row>
                      <hr></hr>
                      <Table>
                        <TableHeader />
                        <TableBody>
                          {(rows) =>
                            rows.length === 0 ? (
                              <EmptyTablePlaceholder noResultsLabel={'Usuarios no encontrados'} />
                            ) : (
                              rows.map((rowData, rowIdx) => (
                                <tr key={rowIdx} className='text-center'>
                                  <td>{rowData.name}</td>
                                  <td>{rowData.lastname}</td>
                                  <td>{rowData.identification}</td>
                                  <td>
                                    <div className='btn-group'>

                                      <a className="btn btn-primary btn-sm rounded-pill" href="#open-modal-branch-user" onClick={() => editBranchUserFunction(rowData)} data-bs-toggle="tooltip" data-bs-placement="top" title="Editar Usuario"> <FaPenAlt /></a>
                                      &nbsp;
                                      <button className='btn btn-danger btn-sm ms-1 rounded-pill' data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar Usuario" onClick={() => { if (window.confirm('¿Desea eliminar el usuario de la Sucursal?')) deleteBranchUserFunction(rowData._id) }}>
                                        <span><FaTrash /></span>
                                      </button>

                                    </div>
                                  </td>
                                </tr>

                              )
                              )
                            )
                          }
                        </TableBody>
                      </Table>
                    </DatatableWrapper>


                    <div id="open-modal-branch-user" className="modal-window-internal">
                      <div>
                        <b><h5>
                          {isCreateBranchUser ? 'Agregar Usuario' : 'Editar Usuario'}
                        </h5></b>
                        <a href="#" id="close-user-branch" title="Close" className="modal-close">&#x2715;</a>
                        <hr></hr>
                        <div className='row'>
                          <div className="col-md-12">

                            {editUser == false ? (
                              <div className='row'>
                                <div className="row">
                                  <div className="col-md-2">
                                    <label><b>Búsqueda:</b></label>
                                  </div>
                                  <div className="col-md-8">
                                    <input
                                      type='text'
                                      name='inputSearchUser'
                                      placeholder='Usuarios por identificación, email o teléfono'
                                      value={inputSearchUser}
                                      style={({ width: '100%' })}
                                      onChange={(event) => setInputSearchUser(event.target.value)}
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <span className="d-inline-block" tabIndex="0" data-bs-toggle="tooltip" title="Buscar">
                                      <button type='button' className='btn btn-primary btn-sm rounded-pill'
                                        onClick={() => formValidationSearchUser()}>
                                        <FaSearch />
                                      </button>
                                    </span>
                                    &nbsp;
                                    <span className="d-inline-block" tabIndex="0" data-bs-toggle="tooltip" title="Limpiar">
                                      <button className='btn btn-primary btn-sm rounded-pill'
                                        onClick=
                                        {() => cleanUser()}>
                                        <FaBroom />
                                      </button>
                                    </span>
                                  </div>
                                </div>
                                &nbsp;
                                <div className='row text-center'>
                                  {errorsListUser ? (<span className='text-danger'>{errorsListUser}</span>) : ''}
                                </div>
                                <br></br>
                                <hr></hr>
                              </div>

                            ) : ''}

                          </div>
                        </div>

                        <div className='row'>

                          {editUser ? (
                            <div className="col-md-12">

                              <div className="alert alert-primary text-center" role="alert">
                                Editar un usuario solo se puede realizar desde el perfil de cada usuario
                              </div>
                            </div>) : ''}
                          {editUser == false ? (
                            <div className="col-md-6">
                              <label htmlFor="typeIdentificationUser"><b>Tipo Identificación:</b></label>
                              <select onChange={(event) => setTypeIdentificationUser(event.target.value)}
                                name='typeIdentificationUser' className='form-control' value={typeIdentificationUser}>
                                <option value="" >Seleccione una opción</option>
                                <option value="RUC" >RUC</option>
                                <option value="Cedula" >Cedula</option>
                                <option value="Pasaporte" >Pasaporte</option>
                              </select>
                            </div>) : (
                            <div className="col-md-6">
                              <label><b>Tipo Identificación:</b></label><br></br>
                              <label>{typeIdentificationUser == '' ? 'No ha ingresado' : typeIdentificationUser}</label>
                              <br></br>
                            </div>)}

                          {editUser == false ? (
                            <div className="col-md-6">
                              <label htmlFor="identificationUser"><b>Identificación:</b></label>
                              <input
                                type='text'
                                name='identificationUser'
                                value={identificationUser}
                                onChange={(event) => setIdentificationUser(event.target.value)}
                                className='form-control'
                              />
                            </div>) : (
                            <div className="col-md-6">
                              <label><b>Identificación:</b></label><br></br>
                              <label>{identificationUser == '' ? 'No ha ingresado' : identificationUser}</label>
                              <br></br>
                            </div>)}

                          {editUser == false ? (
                            <div className="col-md-6">
                              <label htmlFor="nameUser"><b>Nombres:</b></label>
                              <input
                                type='text'
                                name='nameUser'
                                value={nameUser}
                                onChange={(event) => setNameUser(event.target.value)}
                                className='form-control'
                              />
                            </div>) : (
                            <div className="col-md-6">
                              <label><b>Nombres:</b></label><br></br>
                              <label>{nameUser == '' ? 'No ha ingresado' : nameUser}</label>
                              <br></br>
                            </div>)}

                          {editUser == false ? (
                            <div className="col-md-6">
                              <label htmlFor="lastNameUser"><b>Apellidos:</b></label>
                              <input
                                type='text'
                                name='lastNameUser'
                                value={lastNameUser}
                                onChange={(event) => setLastNameUser(event.target.value)}
                                className='form-control'
                              />
                            </div>) : (
                            <div className="col-md-6">
                              <label><b>Apellidos:</b></label><br></br>
                              <label>{lastNameUser == '' ? 'No ha ingresado' : lastNameUser}</label>
                              <br></br>
                            </div>)}
                        </div>
                        {editUser ? (<hr></hr>) : ''}

                        <div className="row">
                          <div className='row'>&nbsp;</div>
                          <div className='row col-md-12'>
                            <div className="col-md-4">
                              <p style={({ display: 'none' })}>{idUser}</p>
                            </div>
                            <div className="col-md-4">
                              <button type='button' onClick={addBranchUser} className='btn btn-primary form-control' disabled={false} data-bs-toggle="tooltip" data-bs-placement="top" title="Actualizar Organización" >
                                <AiOutlineUserAdd /> &nbsp;

                                {isLoadingBranch ? (
                                  <span className='spinner-border spinner-border-sm' />
                                ) : ('')}

                                {isCreateBranchUser == false ? ' Actualizar' : ' Crear '}

                              </button>
                            </div>
                            <div className="col-md-4">

                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>) : ''}

                {isSuperAdmin ? (
                  <div className="tab-pane" id="icon-tabpanel-6" role="tabpanel" aria-labelledby="icon-tab-6">
                    <div>
                      <div className="row">
                        <div className="col-md-3">

                        </div>
                        <div className="col-md-3">
                          <label><b>Presincripción Usuarios:</b></label>
                        </div>
                        <div className="col-md-3 text-center">

                          <div className='form-check form-switch form-control'>
                            <input className='form-check-input'
                              type='checkbox'
                              id='isAuth'
                              name='isAuth'
                              value={isAuth}
                              onChange={(event) => showUserPreinscription(event.target.checked)}

                            />
                            <label className='form-check-label' htmlFor='isAuth'>
                              Con Preinscripción?
                            </label>
                          </div>
                          <div className="col-md-3"></div>
                        </div>
                      </div>
                      <br></br>
                      {showAuthProperties ? (
                        <div style={{ border: 'solid black 1px' }}>
                          <br></br>
                          <div className="row" >
                            <div className="col-md-2"></div>
                            <div className="col-md-1 text-center">
                              <label><b>Tipo</b></label>
                            </div>
                            <div className="col-md-7 text-center">
                              <select onChange={(event) => showPreinscriptionDetailValue(event.target.value)}
                                name='authProperType' className='form-control' value={authProperType}>
                                <option value="" >Seleccione una opción</option>
                                <option value="Consultar Usuarios" >Consultar Usuarios (Consulta Servicios Externos de la Aplicacion)</option>
                                <option value="Consultar Usuarios Alerta" >Consultar Usuarios Alerta (Consulta usuarios en base local por Sucursal)</option>
                              </select>
                            </div>


                            <div className="col-md-2"></div>
                          </div>
                          <br></br>
                          {showPreInscripctionDetail ? (
                            <div>
                              <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-1 text-center">
                                  <label><b>Método</b></label>
                                </div>
                                <div className="col-md-2 text-center">
                                  <select onChange={(event) => setAuthProperMethod(event.target.value)}
                                    name='authProperMethod' className='form-control' value={authProperMethod}>
                                    <option value="" >Seleccione una opción</option>
                                    <option value="post" >POST</option>
                                    <option value="get" >GET</option>
                                    <option value="post" >PUT</option>
                                    <option value="get" >DELETE</option>
                                  </select>
                                </div>
                                <div className="col-md-1 text-center">
                                  <label><b>URL:</b></label>
                                </div>
                                <div className="col-md-4 text-center">
                                  <input
                                    type='text'
                                    name='authProperUrl'
                                    value={authProperUrl}
                                    onChange={(event) => setAuthProperUrl(event.target.value)}
                                    className='form-control'
                                  />
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                              <br></br>
                              <div className="row" >
                                <div className="col-md-12 text-center"><b>Cuerpo de la Petición</b></div>
                              </div>
                              <br></br>
                              <div className="row" >
                                <div className="col-md-2"></div>
                                <div className="col-md-2 text-center">
                                  <label><b>Encabezado</b></label>
                                </div>
                                <div className="col-md-2 text-center">
                                  <a className="btn btn-success" href="#open-modal-auth-property-add-header" data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Ingresar un registro en el encabezado de la petición">
                                    <AiOutlinePlusCircle />  &nbsp;Ingresar</a>

                                  <div id="open-modal-auth-property-add-header" className="modal-window-subinternal" style={{ marginTop: '200px' }}>
                                    <div>
                                      <b><h4>
                                        {editAuthPropertyHeader ? 'Editar Clave / Valor ' : 'Ingresar Clave / Valor '}
                                      </h4></b>
                                      <a href="#" id="close-modal-auth-property-add-header" title="Close" className="modal-close" onClick={() => cleanAuthPropertyHeader()} >&#x2715;</a>
                                      <hr></hr>
                                      <div className='row'>
                                        <div className="col-md-12">
                                        </div>
                                      </div>

                                      &nbsp;
                                      <div className='row'>

                                        <div className="col-md-6">
                                          <label htmlFor="authPropertyHeaderKey"><b>Clave:</b></label>
                                          <input
                                            type='text'
                                            name='authPropertyHeaderKey'
                                            value={authPropertyHeaderKey}
                                            onChange={(event) => setAuthPropertyHeaderKey(event.target.value)}
                                            className='form-control'
                                          />
                                        </div>
                                        <div className='col-md-6'>
                                          <label htmlFor="authPropertyHeaderValue"><b>Valor:</b></label>
                                          <input
                                            type='text'
                                            name='authPropertyHeaderValue'
                                            value={authPropertyHeaderValue}
                                            onChange={(event) => setAuthPropertyHeaderValue(event.target.value)}
                                            className='form-control'
                                          />
                                        </div>
                                        <div className='row'>&nbsp;</div>
                                        <div className='row'>
                                          <div className="col-md-6">
                                            <button type='button' className='btn btn-primary form-control' onClick={() => editAuthPropertyHeader ? authPropertyHeaderEditFunction() : authPropertyHeaderAddFunction()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para crear o editar headers" >
                                              &nbsp; {editAuthPropertyHeader ? 'Actualizar' : 'Crear '}
                                            </button>
                                          </div>
                                          <div className="col-md-6">
                                            <button type='button' className='btn btn-primary form-control' onClick={() => cleanAuthPropertyHeader()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Limpiar pantalla">
                                              <FaBroom /> &nbsp; Limpiar
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-2 text-center">
                                  <label><b>Parámetros</b></label>
                                </div>
                                <div className="col-md-2 text-center">
                                  <a className="btn btn-success" href="#open-modal-auth-property-add-params" data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Ingresar un registro en los parametros de la petición">
                                    <AiOutlinePlusCircle />  &nbsp;Ingresar</a>
                                  <div id="open-modal-auth-property-add-params" className="modal-window-subinternal" style={{ marginTop: '200px' }}>
                                    <div>
                                      <b><h4>
                                        {editAuthPropertyParams ? 'Editar Clave / Valor ' : 'Ingresar Clave / Valor '}
                                      </h4></b>
                                      <a href="#" id="close-modal-auth-property-add-params" title="Close" className="modal-close" onClick={() => cleanAuthPropertyParams()} >&#x2715;</a>
                                      <hr></hr>
                                      <div className='row'>
                                        <div className="col-md-12">
                                        </div>
                                      </div>

                                      &nbsp;
                                      <div className='row'>

                                        <div className="col-md-6">
                                          <label htmlFor="authPropertyParamsKey"><b>Clave:</b></label>
                                          <input
                                            type='text'
                                            name='authPropertyParamsKey'
                                            value={authPropertyParamsKey}
                                            onChange={(event) => setAuthPropertyParamsKey(event.target.value)}
                                            className='form-control'
                                          />
                                        </div>
                                        <div className='col-md-6'>
                                          <label htmlFor="authPropertyParamsValue"><b>Valor:</b></label>
                                          <input
                                            type='text'
                                            name='authPropertyParamsValue'
                                            value={authPropertyParamsValue}
                                            onChange={(event) => setAuthPropertyParamsValue(event.target.value)}
                                            className='form-control'
                                          />
                                        </div>
                                        <div className='row'>&nbsp;</div>
                                        <div className='row'>
                                          <div className="col-md-6">
                                            <button type='button' className='btn btn-primary form-control' onClick={() => editAuthPropertyParams ? authPropertyParamsEditFunction() : authPropertyParamsAddFunction()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para crear o editar parametros" >
                                              &nbsp; {editAuthPropertyParams ? 'Actualizar' : 'Crear '}
                                            </button>
                                          </div>
                                          <div className="col-md-6">
                                            <button type='button' className='btn btn-primary form-control' onClick={() => cleanAuthPropertyParams()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Limpiar pantalla">
                                              <FaBroom /> &nbsp; Limpiar
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                              <br></br>
                              <div className="row" >
                                <div className="col-md-2"></div>
                                <div className="col-md-4 text-center">
                                  <table className='table * table-sm table-border'>
                                    <thead className='border-0'>
                                      <tr className='text-center'>
                                        <th>Clave</th>
                                        <th>Valor</th>
                                        <th>Acciones</th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {authProperHeader && authProperHeader.map((listValue, index) => {
                                        return (
                                          <tr key={index} className='text-center'>
                                            <td>{listValue.key}</td>
                                            <td>{listValue.value}</td>
                                            <td>
                                              <div className='btn-group'>
                                                <a className="btn btn-primary btn-sm rounded-pill" href="#open-modal-auth-property-add-header" onClick={() => showEditAuthPropertyHeader(listValue)}
                                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Editar el registro de header" > <FaPenAlt /></a>
                                                &nbsp;
                                                <button className='btn btn-danger btn-sm ms-1 rounded-pill' onClick={(event) => { (window.confirm('Desea eliminar la clave / valor del Encabezado ?')) ? authPropertyHeaderDeleteFunction(listValue._id) : (event.preventDefault()) }}
                                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Eliminar el registro de header">
                                                  <span><FaTrash /></span>
                                                </button>
                                              </div>
                                            </td>
                                          </tr>)
                                      })}
                                    </tbody>
                                  </table>
                                </div>

                                <div className="col-md-4 text-center">
                                  <table className='table * table-sm table-border'>
                                    <thead className='border-0'>
                                      <tr className='text-center'>
                                        <th>Clave</th>
                                        <th>Valor</th>
                                        <th>Acciones</th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {authProperParams && authProperParams.map((listValue, index) => {
                                        return (
                                          <tr key={index} className='text-center'>
                                            <td>{listValue.key}</td>
                                            <td>{listValue.value}</td>
                                            <td>
                                              <div className='btn-group'>
                                                <a className="btn btn-primary btn-sm rounded-pill" href="#open-modal-auth-property-add-params" onClick={() => showEditAuthPropertyParams(listValue)}
                                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Editar el registro de params" > <FaPenAlt /></a>
                                                &nbsp;
                                                <button className='btn btn-danger btn-sm ms-1 rounded-pill' onClick={(event) => { (window.confirm('Desea eliminar la clave / valor de Params ?')) ? authPropertyParamsDeleteFunction(listValue._id) : (event.preventDefault()) }}
                                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Eliminar el registro de params">
                                                  <span><FaTrash /></span>
                                                </button>
                                              </div>
                                            </td>
                                          </tr>)
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                              <br></br>
                              <div className="row" >
                                <div className="col-md-2"></div>
                                <div className="col-md-2 text-center">
                                  <label><b>Cuerpo</b></label>
                                </div>
                                <div className="col-md-2 text-center">
                                  <a className="btn btn-success" href="#open-modal-auth-property-add-body" data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Ingresar un registro en el cuerpo de la petición">
                                    <AiOutlinePlusCircle />  &nbsp;Ingresar</a>

                                  <div id="open-modal-auth-property-add-body" className="modal-window-subinternal" style={{ marginTop: '200px' }}>
                                    <div>
                                      <b><h4>
                                        {editAuthPropertyBody ? 'Editar Clave / Valor ' : 'Ingresar Clave / Valor '}
                                      </h4></b>
                                      <a href="#" id="close-modal-auth-property-add-body" title="Close" className="modal-close" onClick={() => cleanAuthPropertyBody()} >&#x2715;</a>
                                      <hr></hr>
                                      <div className='row'>
                                        <div className="col-md-12">
                                        </div>
                                      </div>

                                      &nbsp;
                                      <div className='row'>

                                        <div className="col-md-6">
                                          <label htmlFor="authPropertyBodyKey"><b>Clave:</b></label>
                                          <input
                                            type='text'
                                            name='authPropertyBodyKey'
                                            value={authPropertyBodyKey}
                                            onChange={(event) => setAuthPropertyBodyKey(event.target.value)}
                                            className='form-control'
                                          />
                                        </div>
                                        <div className='col-md-6'>
                                          <label htmlFor="authPropertyBodyValue"><b>Valor:</b></label>
                                          <input
                                            type='text'
                                            name='authPropertyBodyValue'
                                            value={authPropertyBodyValue}
                                            onChange={(event) => setAuthPropertyBodyValue(event.target.value)}
                                            className='form-control'
                                          />
                                        </div>
                                        <div className='row'>&nbsp;</div>
                                        <div className='row'>
                                          <div className="col-md-6">
                                            <button type='button' className='btn btn-primary form-control' onClick={() => editAuthPropertyBody ? authPropertyBodyEditFunction() : authPropertyBodyAddFunction()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para crear o editar cuerpos" >
                                              &nbsp; {editAuthPropertyBody ? 'Actualizar' : 'Crear '}
                                            </button>
                                          </div>
                                          <div className="col-md-6">
                                            <button type='button' className='btn btn-primary form-control' onClick={() => cleanAuthPropertyBody()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Limpiar pantalla">
                                              <FaBroom /> &nbsp; Limpiar
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-2 text-center">
                                  <label><b>Respuesta</b></label>
                                </div>
                                <div className="col-md-2 text-center">
                                  <a className="btn btn-success" href="#open-modal-auth-property-add-response" data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Ingresar un registro en la respuesta de la petición">
                                    <AiOutlinePlusCircle />  &nbsp;Ingresar</a>
                                  <div id="open-modal-auth-property-add-response" className="modal-window-subinternal" style={{ marginTop: '200px' }}>
                                    <div>
                                      <b><h4>
                                        {editAuthPropertyResponse ? 'Editar Clave / Valor ' : 'Ingresar Clave / Valor '}
                                      </h4></b>
                                      <a href="#" id="close-modal-auth-property-add-response" title="Close" className="modal-close" onClick={() => cleanAuthPropertyResponse()} >&#x2715;</a>
                                      <hr></hr>
                                      <div className='row'>
                                        <div className="col-md-12">
                                        </div>
                                      </div>

                                      &nbsp;
                                      <div className='row'>

                                        <div className="col-md-6">
                                          <label htmlFor="authPropertyResponseKey"><b>Clave:</b></label>
                                          <input
                                            type='text'
                                            name='authPropertyResponseKey'
                                            value={authPropertyResponseKey}
                                            onChange={(event) => setAuthPropertyResponseKey(event.target.value)}
                                            className='form-control'
                                          />
                                        </div>
                                        <div className='col-md-6'>
                                          <label htmlFor="authPropertyResponseValue"><b>Valor:</b></label>
                                          <input
                                            type='text'
                                            name='authPropertyResponseValue'
                                            value={authPropertyResponseValue}
                                            onChange={(event) => setAuthPropertyResponseValue(event.target.value)}
                                            className='form-control'
                                          />
                                        </div>
                                        <div className='row'>&nbsp;</div>
                                        <div className='row'>
                                          <div className="col-md-6">
                                            <button type='button' className='btn btn-primary form-control' onClick={() => editAuthPropertyResponse ? authPropertyResponseEditFunction() : authPropertyResponseAddFunction()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para crear o editar respuesta" >
                                              &nbsp; {editAuthPropertyResponse ? 'Actualizar' : 'Crear '}
                                            </button>
                                          </div>
                                          <div className="col-md-6">
                                            <button type='button' className='btn btn-primary form-control' onClick={() => cleanAuthPropertyResponse()} data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Limpiar pantalla">
                                              <FaBroom /> &nbsp; Limpiar
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                              <br></br>
                              <div className="row" >
                                <div className="col-md-2"></div>
                                <div className="col-md-4 text-center">
                                  <table className='table * table-sm table-border'>
                                    <thead className='border-0'>
                                      <tr className='text-center'>
                                        <th>Clave</th>
                                        <th>Valor</th>
                                        <th>Acciones</th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {authProperBody && authProperBody.map((listValue, index) => {
                                        return (
                                          <tr key={index} className='text-center'>
                                            <td>{listValue.key}</td>
                                            <td>{listValue.value}</td>
                                            <td>
                                              <div className='btn-group'>
                                                <a className="btn btn-primary btn-sm rounded-pill" href="#open-modal-auth-property-add-body" onClick={() => showEditAuthPropertyBody(listValue)}
                                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Editar el registro del cuerpo" > <FaPenAlt /></a>
                                                &nbsp;
                                                <button className='btn btn-danger btn-sm ms-1 rounded-pill' onClick={(event) => { (window.confirm('Desea eliminar la clave / valor del cuerpo ?')) ? authPropertyBodyDeleteFunction(listValue._id) : (event.preventDefault()) }}
                                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Eliminar el registro de cuerpo">
                                                  <span><FaTrash /></span>
                                                </button>
                                              </div>
                                            </td>
                                          </tr>)
                                      })}
                                    </tbody>
                                  </table>
                                </div>

                                <div className="col-md-4 text-center">
                                  <table className='table * table-sm table-border'>
                                    <thead className='border-0'>
                                      <tr className='text-center'>
                                        <th>Clave</th>
                                        <th>Valor</th>
                                        <th>Acciones</th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {authProperResponse && authProperResponse.map((listValue, index) => {
                                        return (
                                          <tr key={index} className='text-center'>
                                            <td>{listValue.key}</td>
                                            <td>{listValue.value}</td>
                                            <td>
                                              <div className='btn-group'>
                                                <a className="btn btn-primary btn-sm rounded-pill" href="#open-modal-auth-property-add-response" onClick={() => showEditAuthPropertyResponse(listValue)}
                                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Editar el registro de response" > <FaPenAlt /></a>
                                                &nbsp;
                                                <button className='btn btn-danger btn-sm ms-1 rounded-pill' onClick={(event) => { (window.confirm('Desea eliminar la clave / valor de la respuesta ?')) ? authPropertyResponseDeleteFunction(listValue._id) : (event.preventDefault()) }}
                                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Clic para Eliminar el registro de la respuesta">
                                                  <span><FaTrash /></span>
                                                </button>
                                              </div>
                                            </td>
                                          </tr>)
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                              <br></br>
                            </div>) : ''}

                        </div>) : ''}
                      <br></br>
                      <div className="row">
                        <div className="col-md-5"></div>
                        <div className="col-md-2 text-center">
                          <button type='button' onClick={() => updateConfigurations()} className='btn btn-primary form-control' title='Actualizar configuraciones'>
                            <AiOutlineUserAdd /> &nbsp;

                            {isLoadingBranch ? (
                              <span className='spinner-border spinner-border-sm' />
                            ) : ('')}

                            Actualizar
                          </button>
                        </div>
                        <div className="col-md-5"></div>
                      </div>

                    </div>
                  </div>) : ''}

              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  )
}

export default FormBranches
